import CityPageTemplate from './CityPageTemplate';

export default function OcoeePage() {
  return (
    <CityPageTemplate
      city="Ocoee"
      county="Orange"
      slug="ocoee"
      zipCodes={['34761']}
      neighborhoods={['Downtown Ocoee', 'Prairie Lake', 'Silver Star corridor', 'West Orange area', 'Arden Park']}
      localContext="Ocoee is a fast-growing west Orange County community along the Silver Star corridor, where families and businesses alike need reliable, high-quality cleaning."
      metaDescription="Professional residential and commercial cleaning services in Ocoee, FL. Serving ZIP code 34761. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
